import PropTypes from 'prop-types';
import { createContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// third-party
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import axios from 'axios';

// project imports
import Loader from '../ui-component/Loader';
import configData from '../config';

import { LOGIN, LOGOUT } from '../store/actions';

// firebase initialize
if (!firebase.apps.length) {
    firebase.initializeApp({
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
        // measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
    });
}

// ==============================|| FIREBASE CONTEXT & PROVIDER ||============================== //

const FirebaseContext = createContext(null);

export const FirebaseProvider = ({ children }) => {
    const dispatch = useDispatch();
    const account = useSelector((state) => state.account);

    useEffect(
        () =>
            firebase.auth().onAuthStateChanged(async (user) => {
                if (user) {
                    if (user.email.endsWith('@harmonytx.org')) {
                        try {
                            const url = `${configData.API_SERVER}employee?email=${encodeURIComponent(user.email)}`;
                            const response = await axios.get(url, {
                                headers: { Authorization: 'Token ' + configData.TOKEN }
                            });
                            const results = response.data.results || response.data || [];
                            const employee = results[0];

                            if (employee && employee.is_recieving_bullying_submission) {
                                dispatch({
                                    type: LOGIN,
                                    payload: {
                                        isLoggedIn: true,
                                        user: {
                                            id: user.uid,
                                            email: user.email,
                                            name: user.displayName,
                                            photoURL: user.photoURL
                                        }
                                    }
                                });
                            } else {
                                const msg = employee
                                    ? 'You do not have permission to access this portal.'
                                    : 'No account found for this email address.';
                                sessionStorage.setItem('adminLoginError', msg);
                                await firebase.auth().signOut();
                                dispatch({ type: LOGOUT });
                            }
                        } catch {
                            sessionStorage.setItem('adminLoginError', 'Failed to verify account. Please try again.');
                            await firebase.auth().signOut();
                            dispatch({ type: LOGOUT });
                        }
                    } else {
                        dispatch({
                            type: LOGOUT
                        });
                    }
                } else {
                    dispatch({
                        type: LOGOUT
                    });
                }
            }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [dispatch]
    );

    const firebaseEmailPasswordSignIn = (email, password) => firebase.auth().signInWithEmailAndPassword(email, password);

    const firebaseGoogleSignIn = () => {
        const provider = new firebase.auth.GoogleAuthProvider();

        return firebase.auth().signInWithPopup(provider);
    };

    const firebaseRegister = async (email, password) => firebase.auth().createUserWithEmailAndPassword(email, password);

    const logout = () => firebase.auth().signOut();

    const resetPassword = async (email) => {
        await firebase.auth().sendPasswordResetEmail(email);
    };

    const updateProfile = () => {};
    if (account.isInitialized !== undefined && !account.isInitialized) {
        return <Loader />;
    }

    return (
        <FirebaseContext.Provider
            value={{
                ...account,
                firebaseRegister,
                firebaseEmailPasswordSignIn,
                login: () => {},
                firebaseGoogleSignIn,
                logout,
                resetPassword,
                updateProfile
            }}
        >
            {children}
        </FirebaseContext.Provider>
    );
};

FirebaseProvider.propTypes = {
    children: PropTypes.node
};

export default FirebaseContext;
